<div class="container" *ngIf="item" [innerHTML]="item.content"></div>
